import type { BlockManifest } from '@template-ui/blocks';
import { votingCodes } from './voting.models';
const retainedVotingBlocks: BlockManifest[] = votingCodes.map(
  (code, index) => ({
    provider: 'voting',
    code,
    version: 1,
    name: ['Voting population', 'Conduct vote', 'Quorum result'][index],
    description: [
      'Confirm the identified people eligible to vote, manually or from a hearing panel.',
      'Conduct attributable voting against a confirmed population.',
      'Evaluate a closed round using the configured quorum rules.',
    ][index],
    category: 'Voting and decisions',
    keywords: ['voting', 'quorum', 'panel', 'population'],
    contextNeeds: ['workflowInstanceId', 'stepOccurrenceId'],
    reads: [
      {
        code,
        version: 1,
        parameterContract: { code: code + '.parameters', version: 1 },
        dataContract: { code: code + '.output', version: 1 },
        parameters: { occurrenceId: 'stepOccurrenceId' },
      },
    ],
    settingsSchema: {
      code: code + '.settings',
      version: 1,
      fields: {
        sourceKind: {
          type: 'enum',
          required: true,
          values: ['manual', 'hearing-panel'],
        },
        hearingReferenceField: {
          type: 'string',
          required: false,
          maxLength: 120,
        },
        votingRolesJson: { type: 'string', required: false, maxLength: 4000 },
        populationNodeId: { type: 'string', required: false, maxLength: 120 },
        roundNodeId: { type: 'string', required: false, maxLength: 120 },
        question: { type: 'string', required: false, maxLength: 1000 },
        captureMode: {
          type: 'enum',
          required: true,
          values: ['personal', 'recorded', 'both'],
        },
        rulesJson: { type: 'string', required: false, maxLength: 2000 },
      },
    },
    placements: [
      { host: 'step-shell', region: 'main' },
      { host: 'step-shell', region: 'supporting' },
    ],
    layout: {
      widths: ['full'],
      minimumWidthPx: 250,
      minimumHeightPx: 100,
      responsive: 'stack-in-order',
    },
    instances: 'single-per-workspace',
  }),
);
export const votingBlockManifests: BlockManifest[] = [
  ...retainedVotingBlocks,
  {
    ...retainedVotingBlocks[1],
    version: 2,
    name: 'Conduct vote and quorum',
    description:
      'Record panel votes and capture the quorum result together when the vote closes.',
  },
];
